/**
 * AFC Bookstore - Custom JavaScript
 * ===================================
 * Pre-order notification system & custom enhancements
 *
 * Theme hooks available:
 *   document.addEventListener('variant:changed', function(event) {
 *     var variant = event.detail.variant;
 *   });
 *   document.addEventListener('product:added', function(event) {
 *     var variant = event.detail.variant;
 *     var quantity = event.detail.quantity;
 *   });
 */

(function () {
  'use strict';

  /* ==========================================================================
     1. Pre-order Notification Forms
     Uses Shopify's built-in customer API to register interest.
     Sends notification email via Shopify Flow / contact form endpoint.
     ========================================================================== */

  function initPreorderNotifyForms() {
    var forms = document.querySelectorAll('.preorder-notify-form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', handleNotifySubmit);
    });
  }

  function handleNotifySubmit(e) {
    e.preventDefault();
    var form = e.target;
    var emailInput = form.querySelector('input[type="email"]');
    var msgEl = form.querySelector('.preorder-notify-message');
    var submitBtn = form.querySelector('button[type="submit"]');
    var email = emailInput ? emailInput.value.trim() : '';
    var productTitle = form.getAttribute('data-product-title') || 'Pre-order item';

    if (!email || !isValidEmail(email)) {
      showMessage(msgEl, '請輸入有效的郵箱地址 Please enter a valid email address.', 'error');
      return;
    }

    // Disable button during submission
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = '提交中... Submitting...';
    }

    // Submit via Shopify contact form API
    var formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[email]', email);
    formData.append('contact[body]',
      'Pre-order notification request for: ' + productTitle +
      '\nVariant: ' + (form.getAttribute('data-variant-id') || 'N/A') +
      '\nEmail: ' + email +
      '\nDate: ' + new Date().toISOString()
    );
    formData.append('contact[tags]', 'preorder-notify');

    fetch('/contact#contact_form', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(function (response) {
      if (response.ok || response.redirected) {
        showMessage(msgEl,
          '✅ 感謝您的訂閱！到貨後我們會通知您。Thank you! We will notify you when available.',
          'success'
        );
        if (emailInput) emailInput.value = '';

        // Store in localStorage for reference
        try {
          var stored = JSON.parse(localStorage.getItem('afc_preorder_notify') || '[]');
          stored.push({ email: email, product: productTitle, date: new Date().toISOString() });
          localStorage.setItem('afc_preorder_notify', JSON.stringify(stored));
        } catch (err) { /* silently fail */ }
      } else {
        throw new Error('Submit failed');
      }
    })
    .catch(function () {
      showMessage(msgEl,
        '❌ 提交失敗，請稍後再試或直接聯繫我們：book@afcinc.org\nSubmission failed. Please try again or contact us directly.',
        'error'
      );
    })
    .finally(function () {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.closest('.preorder-notify-form--banner')
          ? '訂閱通知 Subscribe'
          : '通知我 Notify Me';
      }
    });
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showMessage(el, text, type) {
    if (!el) return;
    el.style.display = 'block';
    el.textContent = text;
    el.style.color = type === 'error' ? '#c0392b' : '#27ae60';
    el.style.fontSize = '0.85em';
    el.style.padding = '6px 0';

    if (type === 'success') {
      setTimeout(function () {
        el.style.display = 'none';
      }, 8000);
    }
  }

  /* ==========================================================================
     2. Pre-order Badge Enhancement
     Automatically adds pre-order badges to product cards tagged with "pre-order"
     ========================================================================== */

  function initPreorderBadges() {
    var productCards = document.querySelectorAll('.product-item__label-list');
    productCards.forEach(function (labelList) {
      var card = labelList.closest('.product-item');
      if (!card) return;

      // Check if card already has a preorder badge
      if (card.querySelector('.preorder-badge')) return;

      // Check product link for pre-order template
      var link = card.querySelector('a[href*="pre-order"]');
      if (link) {
        var badge = document.createElement('span');
        badge.className = 'product-item__label product-item__label--preorder';
        badge.textContent = '預購 Pre-order';
        badge.style.cssText = 'background:var(--primary-button-background,#5b7395);color:var(--primary-button-text-color,#fff);';
        labelList.appendChild(badge);
      }
    });
  }

  /* ==========================================================================
     3. Smooth Scroll for Anchor Links
     ========================================================================== */

  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ==========================================================================
     4. Lazy Load Enhancement for Images
     Ensures native lazy loading is applied to product images
     ========================================================================== */

  function initLazyLoad() {
    if ('loading' in HTMLImageElement.prototype) {
      var images = document.querySelectorAll('img[data-src]:not([loading])');
      images.forEach(function (img) {
        img.setAttribute('loading', 'lazy');
      });
    }
  }

  /* ==========================================================================
     Initialize on DOM Ready
     ========================================================================== */

  function init() {
    initPreorderNotifyForms();
    initPreorderBadges();
    initSmoothScroll();
    initLazyLoad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize after Shopify section rendering (for theme editor)
  document.addEventListener('shopify:section:load', function () {
    initPreorderNotifyForms();
    initPreorderBadges();
  });

})();
